import { COVERGO_SAAS_DEV, COVERGO_ME_PROD, COVERGO_GCP_UAT, COVERGO_ASIA_QA } from "../consts.js"
import appConfigCoverGoMEProd from "./appConfigCovergoMEProd.js"

export const walaa = {
	"walaa-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "walaa_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"walaa-studio.dev.me.covergo.com": {
		appConfig: {
			tenantId: "walaa_dev",
			appId: "admin_portal",
		},
		envConfig: {
			// TBD
		},
	},
	"walaa-studio.uat.me.covergo.cloud": {
		appConfig: {
			tenantId: "walaa_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_GCP_UAT,
	},
	"walaa-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "walaa_qa",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-walaa-qa"
		},
	},
	// Walaa ME PROD
	"walaa-studio.me.covergo.com": {
		appConfig: appConfigCoverGoMEProd,
		envConfig: COVERGO_ME_PROD,
	},
	// Walaa Pentest
	"claims2-pentest-studio.uat.me.covergo.cloud": {
		appConfig: {
			tenantId: "claims2_pentest",
			appId: "admin_portal",
		},
		envConfig: COVERGO_GCP_UAT,
	},
}
